import { ContactPerson } from "../../components"

export const GatsbyContactPerson = () => <ContactPerson />
